export default __webpack_public_path__ + "static/media/paydaylicense_AB.8e2be249.JPG";